import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/auth";
import "./login.css";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import { base_URL } from "../../data/constant";
import toast from "react-hot-toast";

export const Login = () => {
  const { setLoggedIn, setCurrentUser } = useAuth();
  const navigate = useNavigate();
  const notify = () => toast("You have been logged in.");

  const login = useMutation(
    ["@login"],
    (data) => axios.post(`${base_URL}/api/user_login`, data),
    {
      onSuccess: (result) => {
        console.log(result.data);
        if (result.data.status === "success") {
          setCurrentUser(result.data.response);
          window.localStorage.setItem("@JWT_Token", result.data.token);
          notify();
          navigate("/");
          setLoggedIn(true);
        }
      },
    }
  );

  const user_email = React.useRef();
  const user_password = React.useRef();

  const handleUserLogin = (e) => {
    e.preventDefault();
    login.mutate({
      email: user_email.current.value,
      password: user_password.current.value,
    });
    console.log({
      email: user_email.current.value,
      password: user_password.current.value,
    });

    // setLoggedIn(true);
    // navigate("/");
  };

  const [inputType, setInputType] = useState("password");

  const handleInputTypeChange = () => {
    setInputType((prev) => (prev === "password" ? "text" : "password"));
  };

  return (
    <main className="lyt__login">
      <h1 className="page__title ">Login</h1>
      <form className="user__form d-flex--c">
        <div className="user__form_input-grp d-flex--c">
          <label>Enter your user name:</label>
          <input
            type="text"
            ref={user_email}
            placeholder="Enter username/email"
          />
        </div>
        <div className="user__form_input-grp d-flex--c">
          <label>Enter your password:</label>
          <span className="user__form_input-grp-password d-flex">
            <input
              type={inputType}
              ref={user_password}
              placeholder="Password"
            />
            <button
              className="null-btn"
              type="button"
              onClick={handleInputTypeChange}
            >
              {inputType === "text" ? (
                <AiOutlineEye color="black" fontSize={24} />
              ) : (
                <AiOutlineEyeInvisible color="black" fontSize={24} />
              )}
            </button>
          </span>
        </div>
        <div className="user__form_link d-flex">
          <NavLink to="/">New user? SignUp</NavLink>
          <NavLink to="/">Forgot Password?</NavLink>
        </div>
        <button className="user__form__button" onClick={handleUserLogin}>
          Login
        </button>
      </form>
    </main>
  );
};
